import { getConfig } from '../utils/sessionStorageUtils';
import axios from './axios';

export const subscribe = async (email: string) => {
  try {
    const result = await axios.post(`/Subscribers`, { email }, getConfig());
    return result.data;
  } catch (e) {
    throw e;
  }
};
